import React, { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";

// Web pública
import ConsultaDeuda from "@/pages/ConsultaDeuda";
import BoletaView from "@/pages/BoletaView";
import PagoExitoso from "@/pages/PagoExitoso";
import PagoFallido from "@/pages/PagoFallido";
import PagoPendiente from "@/pages/PagoPendiente";

// Panel admin
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminPagos from "@/pages/admin/AdminPagos";
import AdminUsuarios from "@/pages/admin/AdminUsuarios";
import AdminCajas from "@/pages/admin/AdminCajas";

// Guard de rutas privadas
const RequireAuth = ({ children, usuario, rolRequerido }) => {
  const location = useLocation();
  if (!usuario) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }
  if (rolRequerido && !rolRequerido.includes(usuario.rol)) {
    return <Navigate to="/admin/dashboard" replace />;
  }
  return children;
};

function App() {
  const [adminUsuario, setAdminUsuario] = useState(null);
  const [cargado, setCargado] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("admin_token");
    const userStr = localStorage.getItem("admin_user");
    if (token && userStr) {
      try {
        // Verificar expiración del JWT sin librería
        const parts = token.split(".");
        if (parts.length === 3) {
          const payload = JSON.parse(atob(parts[1]));
          if (payload.exp * 1000 > Date.now()) {
            setAdminUsuario(JSON.parse(userStr));
          } else {
            localStorage.removeItem("admin_token");
            localStorage.removeItem("admin_user");
          }
        }
      } catch {
        localStorage.removeItem("admin_token");
        localStorage.removeItem("admin_user");
      }
    }
    setCargado(true);
  }, []);

  if (!cargado) return null;

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Web pública */}
          <Route path="/" element={<ConsultaDeuda />} />
          <Route path="/boleta/:numero" element={<BoletaView />} />
          <Route path="/pago/exitoso" element={<PagoExitoso />} />
          <Route path="/pago/fallido" element={<PagoFallido />} />
          <Route path="/pago/pendiente" element={<PagoPendiente />} />

          {/* Admin login */}
          <Route path="/admin/login" element={
            adminUsuario
              ? <Navigate to="/admin/dashboard" replace />
              : <AdminLogin onLogin={setAdminUsuario} />
          } />

          {/* Admin dashboard */}
          <Route path="/admin/dashboard" element={
            <RequireAuth usuario={adminUsuario}>
              <AdminLayout usuario={adminUsuario} onLogout={() => {
                setAdminUsuario(null);
                localStorage.removeItem("admin_token");
                localStorage.removeItem("admin_user");
              }}>
                <AdminDashboard />
              </AdminLayout>
            </RequireAuth>
          } />

          {/* Admin pagos */}
          <Route path="/admin/pagos" element={
            <RequireAuth usuario={adminUsuario}>
              <AdminLayout usuario={adminUsuario} onLogout={() => {
                setAdminUsuario(null);
                localStorage.removeItem("admin_token");
                localStorage.removeItem("admin_user");
              }}>
                <AdminPagos usuario={adminUsuario} />
              </AdminLayout>
            </RequireAuth>
          } />

          {/* Admin usuarios - solo admin */}
          <Route path="/admin/usuarios" element={
            <RequireAuth usuario={adminUsuario} rolRequerido={["admin"]}>
              <AdminLayout usuario={adminUsuario} onLogout={() => {
                setAdminUsuario(null);
                localStorage.removeItem("admin_token");
                localStorage.removeItem("admin_user");
              }}>
                <AdminUsuarios />
              </AdminLayout>
            </RequireAuth>
          } />

          {/* Admin cajas - solo admin */}
          <Route path="/admin/cajas" element={
            <RequireAuth usuario={adminUsuario} rolRequerido={["admin"]}>
              <AdminLayout usuario={adminUsuario} onLogout={() => {
                setAdminUsuario(null);
                localStorage.removeItem("admin_token");
                localStorage.removeItem("admin_user");
              }}>
                <AdminCajas usuario={adminUsuario} />
              </AdminLayout>
            </RequireAuth>
          } />

          <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
